import { render, staticRenderFns } from "./LoanSummaryWidget.vue?vue&type=template&id=1819e1f1&"
import script from "./LoanSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./LoanSummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./LoanSummaryWidget.vue?vue&type=style&index=0&id=1819e1f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports